type SubstrateSearchEndpoint =
    | 'suggestions'
    | 'events'
    | 'init'
    | 'query'
    | 'searchHistory'
    | 'feedback'
    | 'usercontrols';

export default function getSubstrateSearchEndpoint(
    endpoint: SubstrateSearchEndpoint,
    version?: number
) {
    const versionPath = version === 3 ? 'v3' : version === 2 ? 'v2' : 'v1';
    const searchPath = endpoint == 'query' ? 'searchservice' : 'search';

    return `${searchPath}/api/${versionPath}/${endpoint}`;
}
